import { render, staticRenderFns } from "./PowerGuardNavBar.vue?vue&type=template&id=5cb87160&scoped=true&"
import script from "./PowerGuardNavBar.vue?vue&type=script&lang=js&"
export * from "./PowerGuardNavBar.vue?vue&type=script&lang=js&"
import style0 from "./PowerGuardNavBar.vue?vue&type=style&index=0&id=5cb87160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb87160",
  null
  
)

export default component.exports